import dynamic from 'next/dynamic';
const ContactUs = dynamic(() => import('./ContactUs'));
const contactPage = props => <ContactUs {...props} />;
export default contactPage;
